import { EventReservationSource } from '../event/models/event-reservation-source';

export class Constants {
  static readonly UI_MODIFIABLE_SOURCES = [
    EventReservationSource.MANUAL,
    EventReservationSource.RSVP,
    EventReservationSource.UPLOADED
  ];
  static readonly UI_UNLINKABLE_SOURCES = [
    EventReservationSource.OUT_OF_BLOCK
  ];
  static readonly DATE_FORMAT_MMM_DD = 'MMM-dd';
  static readonly DATE_FORMAT_MM_DD_YYYY = 'MMM-dd-yyyy';
  static readonly RSVP_COMPARE_PDF_FILE_NAME_SUFFIX = '_rsvp-compare.pdf';
  static readonly PDF_EMPTY_CELL = '--';
  static readonly SESSION_EXPIRE_WARNING_SECONDS = 120;
  static readonly COUNTRIES_WITH_STATES = ['US', 'CA', 'AU'];
  static readonly COUNTRIES_WITH_POSTAL_CODE = ['US', 'CA'];
  static readonly STATE_INVALID_DUPLICATED = ['PQ', 'NF', 'YU'];
  static readonly STATE_QUEBEC_INVALID = 'PQ';
  static readonly STATE_QUEBEC_VALID = 'QC';
  static readonly STATE_NEW_FOUNDLAND_INVALID = 'NF';
  static readonly STATE_NEW_FOUNDLAND_VALID = 'NL';
  static readonly STATE_YUKON_INVALID = 'YU';
  static readonly STATE_YUKON_VALID = 'YT';
  static readonly INITIAL_FILTER_PARAMS = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"paymentStatus","filterValue":"unpaid"}' +
    ']';
  static readonly INITIAL_FILTER_PARAMS_FUll_AGENCY = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"paymentStatus","filterValue":"unpaid"},' +
    '{"filterField":"paymentStatus","filterValue":"cancelled"}' +
    ']';
  static readonly INITIAL_FILTER_PARAMS_NO_SEARCH = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"includeArchivedEvents","filterValue":"true"}' +
    ']';

  static readonly INITIAL_FILTER_PARAMS_FUll_AGENCY_ARCHIVED = '[' +
  '{"filterField":"paymentStatus","filterValue":"paid"},' +
  '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
  '{"filterField":"paymentStatus","filterValue":"unpaid"},' +
  '{"filterField":"paymentStatus","filterValue":"cancelled"},' +
  '{"filterField":"includeArchivedEvents","filterValue":"true"}' +
  ']';

  static readonly PROPERTY_SEARCH_MAX_RESULTS = 50;
  static readonly PROPERTY_SEARCH_ITEMS_PER_PAGE = 10;

  static readonly SEARCH_DEFAULT_ITEMS_PER_PAGE = 10;
  static readonly SEARCH_DEFAULT_PAGE = 0;

  static readonly EVENTS_NAME_MAX_SIZE = 33;

  static readonly AGENCY_SERVICE_ERROR_RESPONSE = 'Error calling agency service';

  static readonly COMMISSION_TOKEN_KEY = 'commission_token';

  static readonly SORT_DIRECTION_ASC = 'asc';
  static readonly SORT_DIRECTION_DESC = 'desc';

  static readonly DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD = 'matchingPropertyId';

  static readonly DEFAULT_MATCHING_AGENCY_FIELD_SORT_FIELD = 'matchingAgencyId';

  static readonly NOT_PROVIDED_VENDOR_ID_PREFIX = 'NOP@';
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/constants.ts